import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';

import {
  buttonIds,
  getEmailProvider,
  getSniperLink,
  gtmEvents,
} from '@selfserve/react-utils';

const StyledSniperLink = styled('a')(({ theme }: { theme?: any }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  alignSelf: 'center',
  margin: '16px 0 0',
  padding: '10px 24px',
  color: theme.palette.grey[100],
  fontFamily: 'Centra No1',
  fontSize: theme.typography.pxToRem(16),
  fontWeight: 700,
  lineHeight: '1.75rem',
  textDecoration: 'none',
  border: `1px solid ${theme.palette.grey['100']}`,
  borderRadius: '4px',
}));

const StyledProviderLogo = styled.img`
  height: 16px;
  margin-right: 6px;
  pointer-events: none;
`;

interface Props {
  email: string;
}

export const SniperLink = ({ email }: Props) => {
  const { t } = useTranslation();
  const provider = useMemo(() => getEmailProvider(email), [email]);
  const sniperLink = useMemo(() => getSniperLink(provider, email), [provider]);

  const onSniperLinkClick = useCallback(() => {
    if ((window as any).dataLayer) {
      (window as any).dataLayer.push({
        event: gtmEvents.LINK_CLICK,
        email,
      });
    }
  }, []);

  if (!provider) return null;

  return (
    <StyledSniperLink
      onClick={onSniperLinkClick}
      href={sniperLink}
      id={buttonIds.sniperLinkVerify}
      target="_blank"
    >
      <StyledProviderLogo src={`assets/${provider}.svg`} alt={provider} />
      {t('common.open')} {t(`email-providers.${provider}`)}
    </StyledSniperLink>
  );
};
